import { Action, IOWidget, mk_widget, any } from 'widgets-for-react'
import React from 'react'
import { CMSState, Url } from '../../../../cms/blocks/types.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
import Lottie from 'react-lottie';

export type LottiAnimationBlockProps = {
  block_index: number
  animation_data_url: string
  caption: string
}

export type LottiAnimationBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function LottiAnimationBlock<customBlockData, extra_images>(
  props: LottiAnimationBlockProps,
  options?: { style?: LottiAnimationBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {

    return any<Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>>()([

      mk_widget({
        run: _ => (
          <section className="block block--media container container--m grid--block">
            <div className="block__inner">
              <figure className="block__visual">
                <Lottie
                  options={{
                    loop: true,
                    path: props.animation_data_url,
                  }}
                />
                {props.caption && (
                  <figcaption className="block__caption">
                    {props.caption}
                  </figcaption>
                )}
              </figure>
            </div>
          </section>
        )
      })
    ])
  }
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/lottiAnimationBlock.tsx